export function post() {
  return {
    url: `/api/users/me/heartbeat`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
    body: JSON.stringify([]),
  }
}
